// extracted by mini-css-extract-plugin
export default {"paddingRightMd":"_2NW5J-l5","paddingLeftMd":"Fm92yRLk","tabs":"f2iCikDO"};